(() => {
    let timeout
    waitForSubscribe()
    function waitForSubscribe() {
      clearTimeout(timeout)
      if(!!window.subscribe === false) {
        timeout = setTimeout(waitForSubscribe, 50)
        return
      }
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        update()
      })
    }
    update()
    function update() {
      const items = document.querySelectorAll('[data-cpbcts]')
      items.forEach(item => {
        const remove = item.querySelector('cart-remove-button > a')
        const itemTimestamp = item.getAttribute('data-cpbcts')
        remove.addEventListener('click', async e => {
          e.preventDefault()
          e.stopPropagation()
          const relatedItems = document.querySelectorAll(`[data-cpbcts="${itemTimestamp}"]`)
          const result = await Swal.fire({
            title: `<strong>${cpbcCartScriptSettings.popupTitle}</strong>`,
            html: cpbcCartScriptSettings.popupText.replaceAll('[[quantity]]', relatedItems.length),
            showConfirmButton: true,
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: cpbcCartScriptSettings.popupConfirmBtn,
            denyButtonText: cpbcCartScriptSettings.popupDenyBtn,
            icon: 'warning'
          })
          if(result.isConfirmed !== true) return
          let updates = {}
          relatedItems.forEach(relatedItem => {
            updates[relatedItem.getAttribute('data-key')] = 0
          })
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({updates})
          }).then(() => {
            location.reload()
          })        
        })
      })
    }

  })()